// @flow
import React from 'react';
import { Field } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import i18n from 'i18n-js';

import {
  RenderInput,
  RenderStudentStopsScheduling,
  RenderUserContacts,
  RenderProfileImagePicker,
  RenderAddressInputs,
} from '../FieldRenderer/index';

import styles from './createUserForm.css';
import { rowsDefinition, validateContact } from './utils';
import AddressInput from './AddressInput';

type StudentFormPropsType = {
  onAddContact: Function,
  onRemoveContact: Function,
  onEditContact: Function,
}

const StudentForm = ({
  onAddContact,
  onRemoveContact,
  onEditContact,
}: StudentFormPropsType) => (
  <Grid>
    <Row>
      <Col className={styles.input} xs={6}>
        <Field
          type="text"
          label={`${i18n.t('labels.code')}: (${i18n.t('labels.emptyToAuto')})`}
          name="code"
          component={RenderInput}
          placeholder={i18n.t('labels.writeCodeHere')}
        />
      </Col>
      <Col className={styles.input} xs={6}>
        <Field
          type="text"
          label="Teléfono:"
          name="phone"
          component={RenderInput}
          placeholder="Ej.: 42491094"
        />
      </Col>
    </Row>
    <Row>
      <Col className={styles.input} xs={6}>
        <Field
          type="text"
          label={i18n.t('labels.name', { count: 1 })}
          name="first_name"
          component={RenderInput}
          placeholder="Ej.: Mario"
        />
      </Col>
      <Col className={styles.input} xs={6}>
        <Field
          type="text"
          label="Apellido:"
          name="last_name"
          component={RenderInput}
          placeholder="Ej.: Robles"
        />
      </Col>
    </Row>
    <Row>
      <Col className={styles.input} xs={6}>
        <Field
          type="text"
          label="Email:"
          name="email"
          component={RenderInput}
          placeholder="Ej.: test@edoo.io"
        />
      </Col>
      <Col className={`${styles.input} ${styles.imageSelectorContainer}`} xs={6}>
        <Field name="profile_picture" component={RenderProfileImagePicker} />
      </Col>
    </Row>
    <Field name="complex_address" component={RenderAddressInputs} />
    <div className={styles.spacer}/>
    <Row>
      <Col className={styles.input} xs={12}>
        <p className={styles.dividerTitle}>Agrega contactos al estudiante</p>
      </Col>
    </Row>
    <Row>
      <Col className={styles.input} xs={12}>
        <Field
          value={[]}
          name="parents"
          component={RenderUserContacts}
          onAdd={onAddContact}
          onRemove={onRemoveContact}
          onEdit={onEditContact}
          canEditValues
          canManuallyAdd
          validation={validateContact}
          inputsDefinition={rowsDefinition}
        />
      </Col>
    </Row>
    <br/>
    <br/>
    <Row>
      <Col className={styles.input} xs={12}>
        <p className={styles.dividerTitle}>Agrega paradas al estudiante</p>
      </Col>
    </Row>
    <Row>
      <Col className={styles.input} xs={12}>
        <Field
          value={[]}
          name="stops_scheduling_going"
          component={RenderStudentStopsScheduling}
          headerLabel={i18n.t('routes.stopsGoing')}
          routeType="going"
        />
      </Col>
    </Row>
    <Row>
      <Col className={`${styles.input} ${styles.stopsContainer}`} xs={12}>
        <Field
          value={[]}
          name="stops_scheduling_returning"
          component={RenderStudentStopsScheduling}
          headerLabel={i18n.t('routes.stopsReturning')}
          routeType="returning"
        />
      </Col>
    </Row>
  </Grid>
);

export default StudentForm;



// WEBPACK FOOTER //
// ./src/scripts/components/CreateUserForm/StudentForm.jsx